import React, { useState, useEffect } from 'react';
import { useSnapshot } from 'valtio';
import { useNavigate } from 'react-router-dom';
import { state } from '../store/global';
import API from '../lib/api';

import ComeBack from '../components/common/ComeBack';
import RechargeItem from '../components/common/RechargeItem';
import NetworkItem from '../components/common/NetworkItem';
import CurrencyInputbox from '../components/common/CurrencyInputbox';
import ExchangeRate from '../components/common/ExchangeRate';
import NormalButton from '../components/common/NormalButton';

import PseIcon from '../assets/images/pse.png';
import Pse2xIcon from '../assets/images/pse_2x.png';
import BlockchainIcon from '../components/svg/BlockchainIcon';
import ArrowCircleUpRightIcon from '../components/svg/ArrowCircleUpRightIcon';

import blockchainImage from '../assets/images/blockchain/blockchain.png';
import ethereumImage from '../assets/images/blockchain/ethereum.png';
import bnbImage from '../assets/images/blockchain/bnb.png';
import tetherImage from '../assets/images/blockchain/tether.png';
import solanaImage from '../assets/images/blockchain/solana.png';
import colombiaFlag from '../assets/images/country/colombia.png';
import usFlag from '../assets/images/country/us.png';
import QrcodeImage from '../assets/images/qrcode.png';

const blockchains = [
  // {
  //   icon: blockchainImage,
  //   name: 'Bitcoin',
  //   currency: 'BTC',
  // },
  // {
  //   icon: ethereumImage,
  //   name: 'Ethereum',
  //   currency: 'ETH',
  // },
  // {
  //   icon: bnbImage,
  //   name: 'BNB Chain',
  //   currency: '',
  // },
  // {
  //   icon: tetherImage,
  //   name: 'Tether',
  //   currency: 'USDT',
  // },
  {
    icon: solanaImage,
    name: 'Solana',
    currency: 'USDC',
  },
];

export default function Rewards() {
  const snap = useSnapshot(state);
  const navigate = useNavigate();

  const [progress, setProgress] = useState(0);
  const [rechargeType, setRechargeType] = useState(''); // PSE, BLOCKCHAIN
  const [blockchain, setBlockchain] = useState('');
  const [copValue, setCopValue] = useState('');
  const [dollarValue, setDollarValue] = useState('');
  const [walletAddress, setWalletAddress] = useState('');
  const [copied, setCopied] = useState(false);
  const [checkoutLink, setCheckoutLink] = useState('');
  const [exchangeRate, setExchangeRate] = useState(0);
  const [submitting, setSubmitting] = useState(false);
  const [exchangeRate_, setExchangeRate_] = useState();
  const [dualBalanceEnabled, setDualBalanceEnabled] = useState(false); // recarga en pesos para whitelist

  useEffect(() => {
    getExchangeRate_();
    // ¿usuario dual-balance? -> recarga aterriza en pesos (sin conversion ni fee)
    API.get('user/getDashboardInfo')
      .then((res) => setDualBalanceEnabled(!!res.data?.data?.dual_balance_enabled))
      .catch(() => {});
    // Prellenado desde el Oraculo ("recarga 100 mil pesos"): ?via=pse&monto=100000
    // salta directo al paso del monto con el valor puesto — el cliente solo autoriza.
    const q = new URLSearchParams(window.location.search);
    const montoPre = parseInt(q.get('monto') || '', 10);
    if ((q.get('via') || '').toLowerCase() === 'pse' && Number.isFinite(montoPre) && montoPre > 0) {
      setRechargeType('PSE');
      setCopValue(String(montoPre));
      setProgress(1);
    }
  }, [])
  const getExchangeRate_ = async () => {
    const res = await API.get('transaction/get_exchange_rate');
    if(res.data.success == true) {
      setExchangeRate(res.data.rate);
    } else {
      console.log(res.data);
    }
  }

  useEffect(() => {
    const developerFee = parseFloat(import.meta.env.VITE_DEVELOPER_FEE);
    setDollarValue((copValue / exchangeRate) * (1 - developerFee / 100.0));
  }, [copValue, exchangeRate]);

  const onChangeRechargeType = (type) => {
    setRechargeType(type);
    setProgress(progress + 1);
  };
  const onChangeNetwork = (type) => {
    API.get('user/getWalletAddress')
      .then((res) => {
        console.log('res: ', res);
        setBlockchain(type);
        setProgress(progress + 1);
        setWalletAddress(res.data.data.address);
      })
      .catch((err) => {
        console.log('err: ', err);
        if (err.status == 401) navigate('/login');
      });
  };
  const onCopyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(walletAddress);
      setCopied(true);
    } catch (err) {
      console.error('Failed to copy!', err);
    }
  };

  const onPurchaseOrder = async () => {
    if (submitting) return;
    setSubmitting(true);

    await API.post('transaction/onRampByPayvalida', {
      amount: copValue,
      exchangeRate: exchangeRate,
    })
      .then((res) => {
        console.log('res: ', res);
        setCheckoutLink(res.data.data.checkout);
        setProgress(progress + 1);
        setSubmitting(false);
      })
      .catch((err) => {
        console.log('err: ', err);
        setSubmitting(false);
        if (err.status == 401) navigate('/login');
      });
  };

  const onCheckout = () => {
    const url = `https://${checkoutLink}`;
    window.open(url, '_blank', 'noopener,noreferrer');
    setProgress(0);
  };

  return (
    <div className="recargar-ola">
      <div className="recargar-ola__panel">
        {progress == 0 && (
          <>
            <div className="space-y-2">
              <ComeBack
                text="Recargar"
                onClick={() => navigate('/dashboard')}
              />
              <p className="recargar-ola__sub">
                Selecciona el método de recarga
              </p>
            </div>

            <div className="space-y-2">
              <RechargeItem
                leftIcon={<img src={PseIcon} className="w-full h-full" />}
                title="PSE"
                subTitle="(Pagos seguros en línea)"
                onClick={() => onChangeRechargeType('PSE')}
              />
              <RechargeItem
                leftIcon={<BlockchainIcon />}
                title="Dirección de blockchain"
                onClick={() => onChangeRechargeType('BLOCKCHAIN')}
              />
            </div>
          </>
        )}

        {progress == 1 && (
          <>
            {rechargeType == 'PSE' && (
              <>
                <div className="space-y-2">
                  <ComeBack
                    text="Recargar a través de PSE"
                    onClick={() => setProgress(progress - 1)}
                  />
                  <p className="recargar-ola__sub">
                    Ingresa el monto que deseas recargar
                  </p>
                </div>

                {dualBalanceEnabled ? (
                  /* ===== Recarga en PESOS (dual-balance): sin conversion ni fee ===== */
                  <>
                    <div className="space-y-4">
                      <CurrencyInputbox
                        title="Recargas"
                        icon={colombiaFlag}
                        currency="COL"
                        value={copValue}
                        onChange={setCopValue}
                      />
                    </div>
                    <div className="recargar-ola__alert">
                      <p>
                        Tu saldo quedara en <b>pesos</b>. Sin costo de recarga. Podras invertir en
                        Colombia, convertir a dolares para invertir en USA, o enviar al exterior
                        cuando quieras.
                      </p>
                    </div>
                  </>
                ) : (
                  /* ===== Recarga legacy (convierte a USD) ===== */
                  <>
                    <div className="space-y-4">
                      <CurrencyInputbox
                        title="Envias"
                        icon={colombiaFlag}
                        currency="COL"
                        value={copValue}
                        onChange={setCopValue}
                      />
                      <CurrencyInputbox
                        disabled={true}
                        title="Recibes"
                        icon={usFlag}
                        currency="USD"
                        value={dollarValue}
                        onChange={setDollarValue}
                      />
                    </div>

                    <div className="recargar-ola__meta space-y-2">
                      <ExchangeRate colRate={exchangeRate_} rate={exchangeRate} />
                      <p className="recargar-ola__meta">
                        La cotización se actualizará en{' '}
                        <span className="recargar-ola__meta-accent">50 segundos</span>
                      </p>
                    </div>
                  </>
                )}

                <div className="recargar-ola__actions">
                  <NormalButton
                    customClass="bg-[#092F7B] text-white"
                    text="Continuar"
                    onClick={onPurchaseOrder}
                  />
                </div>
              </>
            )}
            {rechargeType == 'BLOCKCHAIN' && (
              <>
                <div className="space-y-2">
                  <ComeBack
                    text="Recargar a través de dirección de Blockchain"
                    onClick={() => setProgress(progress - 1)}
                  />
                  <p className="recargar-ola__sub">
                    Seleccion la red con la que quieres recargar
                  </p>
                </div>

                <div className="space-y-2">
                  {blockchains.map((item, idx) => (
                    <NetworkItem
                      key={idx}
                      item={item}
                      onClick={() => onChangeNetwork(item.name)}
                    />
                  ))}
                </div>
              </>
            )}
          </>
        )}

        {progress == 2 && (
          <>
            {rechargeType == 'PSE' && (
              <>
                <div className="space-y-2">
                  <ComeBack
                    text="Recargar a través de PSE"
                    onClick={() => setProgress(progress - 1)}
                  />
                </div>

                <div>
                  <div className="py-6 space-y-2 text-center">
                    <div className="flex items-center justify-center">
                      <div className="recargar-ola__pse-icon">
                        <img
                          src={Pse2xIcon}
                          alt="pse 2x image"
                          className="w-[73px] h-65px"
                        />
                        <div className="recargar-ola__pse-badge">
                          <ArrowCircleUpRightIcon size="w-6.5 h-6.5" />
                        </div>
                      </div>
                    </div>
                    <div className="py-2 space-y-2">
                      <p className="recargar-ola__body">
                        Estas siendo redireccionado a la página oficial de PSE
                        para completar el pago
                      </p>
                      <p className="recargar-ola__hint">
                        Una vez finalizado el proceso, podrás ver tu recarga
                        reflejada en tu cuenta.
                      </p>
                    </div>
                  </div>

                  <div className="recargar-ola__actions">
                    <NormalButton
                      customClass="bg-[#092F7B] text-white"
                      text="Continuar"
                      onClick={onCheckout}
                    />
                  </div>
                </div>
              </>
            )}

            {rechargeType == 'BLOCKCHAIN' && (
              <>
                <div className="space-y-2">
                  <ComeBack
                    text="Recargar a través de dirección de Blockchain"
                    onClick={() => setProgress(progress - 1)}
                  />
                  <p className="recargar-ola__sub">
                    Transfiere, sin comisiones, desde la billetera seleccionada
                    a tu cuenta Flowex.
                  </p>
                </div>

                <div className="space-y-2 text-center">
                  <p className="recargar-ola__qr-title">
                    Dirección Solana (USDC)
                  </p>
                  <div className="flex items-center justify-center">
                    <div className="recargar-ola__qr-frame">
                      <img
                        src={QrcodeImage}
                        alt="Qrcode"
                        className="w-64 h-64"
                      />
                    </div>
                  </div>
                </div>

                <div className="recargar-ola__wallet">
                  <p className="recargar-ola__wallet-lbl">
                    Dirección de billetera
                  </p>
                  <div className="recargar-ola__wallet-row">
                    <p className="recargar-ola__wallet-addr">
                      {walletAddress}
                    </p>
                    <button
                      onClick={onCopyToClipboard}
                      className="recargar-ola__copy"
                    >
                      <span>{copied ? 'Copiada' : 'Copiar'}</span>
                    </button>
                  </div>
                </div>

                <div className="recargar-ola__actions">
                  <NormalButton
                    customClass="bg-[#092F7B] text-white"
                    text="Volver a inicio"
                    onClick={() => setProgress(0)}
                  />
                </div>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
}
